import React from 'react'
import { Container, H1 } from '../components/index.js'

const PageHeader = ({ title, back, children }) => {
  let headerStyle = ['ncss-brand u-uppercase flex-fill']
  if (back) headerStyle.push('page-title-has-back')

  return (
    <Container section extraClassName='flex-container start page-header'>
      <H1 className={headerStyle.join(' ')}>
        {title}
        {back || null}
      </H1>
      {React.Children.count(children)
        ? <div className='flex-static'>{children}</div>
        : null
      }
    </Container>
  )
}

export default PageHeader



// WEBPACK FOOTER //
// ./client/src/components/PageHeader.js